import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { getResumeErrors, getResumeStatus, selectAllResume } from '../../reducers/resumeSlice'
import Timeline from './timeline'
import Skills from './skills'
import Knowledges from './knowledges'
import Certificates from './certificates'
import LoaderTimeline from './LoaderTimeline';
import TimelineWork from './timelineWork';
import LoaderKnowledges from './LoaderKnowledges';
import LoaderCertificat from './LoaderCertificates';
import LoderSkills from './LoderSkills';

export default function Resume() {
    const AllResume = useSelector(selectAllResume)
    // console.log(AllResume);

    const defultSkills = [{
        title: "عنوان صفحه",
    }]

    return (
        <section data-id="resume" className="animated-section resume">
            <div className="section-content">
                <div className="page-title">
                    <h2>رزومه</h2>
                    <h4>15سال تجربه</h4>
                </div>
                <div className="row">
                    <div className="col-xl-7 col-lg-12 col-md-7">
                        <div className="block-title">
                            <h6 className="title">تحصیلات</h6>
                        </div>

                        {AllResume !== null ? <Timeline timelineEdu={AllResume.timelineEdu} /> : <LoaderTimeline />}
                        <div className="block-title">
                            <h6 className="title">رزومه</h6>
                        </div>
                        {AllResume !== null ? <TimelineWork timelineWork={AllResume.timelineWork} /> : <LoaderTimeline />}

                    </div>
                    <div className="col-xl-5 col-lg-12 col-md-5 mt-sm-4 mt-xl-0">

                        {/* start skills */}
                        {AllResume !== null ? <Skills skills={AllResume.skill} subskills={AllResume.subSkill} /> : <LoderSkills defultSkills={defultSkills} skills={AllResume?.skill} />}
                        {/* <LoderSkills defultSkills={defultSkills} skills={AllResume?.skill} /> */}
                        {/*  end skills  */}

                        <div className="block-title">
                            <h6 className="title">قابلیت ها</h6>
                        </div>
                        {AllResume !== null ? <Knowledges knowledges={AllResume.knowledges} /> : <LoaderKnowledges />}

                    </div>
                    <div className="col-12 mt-4">
                        {/* start certificates */}
                        {AllResume !== null ? <Certificates certificates={AllResume.certificates} /> : <LoaderCertificat />}
                        {/* end certificates */}
                    </div>
                </div>
            </div>
        </section>
    )
}
